export default __webpack_public_path__ + "static/media/00.971f17f8.jpg";